/**
 * Created by Nisarg on 9/5/2017.
 */
import React, {Component} from 'react';
import firebase from 'firebase';
import _HauteFire from '../../Utils/HauteFire';
const HauteFire = new _HauteFire();

export default class SocialManagement extends Component {
    constructor() {
        super();

        this.state = {HauteDetails: {}}
    }

    componentDidMount() {
        const _this = this;
        let hauteRef = firebase.database().ref('HauteDetails');
        hauteRef.on('value', (response) => {
            const HauteDetails = response.val();
            if (HauteDetails != null) {
                if (HauteDetails.hasOwnProperty('socialManagement')) {
                    const socialManagement = HauteDetails.socialManagement;
                    if (socialManagement.hasOwnProperty('facebook')) {
                        document.getElementById("txtFacebook").value = socialManagement.facebook;
                    }
                    if (socialManagement.hasOwnProperty('twitter')) {
                        document.getElementById("txtTwitter").value = socialManagement.twitter;
                    }
                    if (socialManagement.hasOwnProperty('instagram')) {
                        document.getElementById("txtInstagram").value = socialManagement.instagram;
                    }
                    if (socialManagement.hasOwnProperty('pinterest')) {
                        document.getElementById("txtPinterest").value = socialManagement.pinterest;
                    }
                }

                _this.setState({HauteDetails});
            }
        })
    }

    saveSocialLinks() {
        const HauteDetails = this.state.HauteDetails;
        HauteFire.addUpdate("", HauteDetails, "HauteDetails");

        return false;
    }

    render() {
        return (<div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-block">
                        <div className="form-group">
                            <label className="form-control-label" htmlFor="txtFacebook">Facebook</label>
                            <div className="controls">
                                <div className="input-prepend input-group">
                                        <span className="input-group-btn">
                                            <button type="button" className="btn btn-primary">
                                                <i className="fa fa-facebook"></i>
                                            </button>
                                        </span>
                                    <input id="txtFacebook" className="form-control" size="16" type="text"
                                           onInput={(e) => {
                                                const facebook = e.currentTarget.value.trim();
                                                let HauteDetails = this.state.HauteDetails;
                                                HauteDetails.socialManagement = HauteDetails.socialManagement || {};
                                                let socialManagement = HauteDetails.socialManagement;
                                                socialManagement.facebook = facebook;

                                                this.setState({HauteDetails});
                                               }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-control-label" htmlFor="txtTwitter">Twitter</label>
                            <div className="controls">
                                <div className="input-prepend input-group">
                                        <span className="input-group-btn">
                                            <button type="button" className="btn btn-primary">
                                                <i className="fa fa-twitter"></i>
                                            </button>
                                        </span>
                                    <input id="txtTwitter" className="form-control" size="16" type="text"
                                           onInput={(e) => {
                                                const twitter = e.currentTarget.value.trim();
                                                let HauteDetails = this.state.HauteDetails;
                                                HauteDetails.socialManagement = HauteDetails.socialManagement || {};
                                                let socialManagement = HauteDetails.socialManagement;
                                                socialManagement.twitter = twitter;

                                                this.setState({HauteDetails});
                                               }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-control-label" htmlFor="txtInstagram">Instagram</label>
                            <div className="controls">
                                <div className="input-prepend input-group">
                                        <span className="input-group-btn">
                                            <button type="button" className="btn btn-primary">
                                                <i className="fa fa-instagram"></i>
                                            </button>
                                        </span>
                                    <input id="txtInstagram" className="form-control" size="16" type="text"
                                           onInput={(e) => {
                                                const instagram = e.currentTarget.value.trim();
                                                let HauteDetails = this.state.HauteDetails;
                                                HauteDetails.socialManagement = HauteDetails.socialManagement || {};
                                                let socialManagement = HauteDetails.socialManagement;
                                                socialManagement.instagram = instagram;

                                                this.setState({HauteDetails});
                                               }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-control-label" htmlFor="txtPinterest">Pinterest</label>
                            <div className="controls">
                                <div className="input-prepend input-group">
                                        <span className="input-group-btn">
                                            <button type="button" className="btn btn-primary">
                                                <i className="fa fa-pinterest"></i>
                                            </button>
                                        </span>
                                    <input id="txtPinterest" className="form-control" size="16" type="text"
                                           onInput={(e) => {
                                                const pinterest = e.currentTarget.value.trim();
                                                let HauteDetails = this.state.HauteDetails;
                                                HauteDetails.socialManagement = HauteDetails.socialManagement || {};
                                                let socialManagement = HauteDetails.socialManagement;
                                                socialManagement.pinterest = pinterest;

                                                this.setState({HauteDetails});
                                                }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-actions">
                            <button type="submit" className="btn btn-primary" onClick={this.saveSocialLinks.bind(this)}>
                                Save changes
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/views/HauteManagement/SocialManagement/SocialManagement.js